import { SearchOptionsService } from "./SearchOptions.store";
import { CONTRACT_ADDRESS } from "../../constants/tokens";
import tronWeb from "tronweb";

export const getOptions = async (value: string) => {
  try {
    const searchOptionsService = new SearchOptionsService();
    const data = await searchOptionsService.fetchOptions(value);
    return data;
  } catch (e) {
    throw e;
  }
};

export const doSearch = (selection) => {
  try {
    if (
      (typeof selection === "object" || typeof selection === "function") &&
      selection !== null
    ) {
      switch (selection.type) {
        case "Token-TRC10":
        case "Token-TRC20":
        case "Token": {
          switch (selection.value) {
            case "Centric CASH(CNS) TMJWuBDvwvcm6QUWXDaC6GqTyq3FgEmWEt":
              return "/tokens/cash";
            case "Centric RISE(CNR) TYLrbh1pVcx95bop33XQ1iYdh7r3ogEQ8Q":
              return "/tokens/rise";
            default:
              return `/token/${selection.value}`;
          }
        }
        case "Contract": {
          switch (selection.value) {
            case CONTRACT_ADDRESS.rise:
              return `/contracts/${CONTRACT_ADDRESS.rise}`;
            case CONTRACT_ADDRESS.cash:
              return `/contracts/${CONTRACT_ADDRESS.cash}`;
            default:
              return `/contracts/${selection.value}`;
          }
        }
        case "Address":
          return `/account/${selection.value}`;
        case "TxHash":
          return `/transaction/${selection.value}`;
        default:
          return `/search/${selection.value}`;
      }
    } else {
      if (tronWeb.isAddress(selection)) {
        return `/account/${selection}`;
      }
      return `/search/${selection}`;
    }
  } catch (e) {
    throw e;
  }
};
